module.exports = __webpack_public_path__ + "static/media/bipsu.logo.240w.d37e89a6.png";